import { useState } from 'react';
import { DeviceModel } from '@bymason/controller-api-hooks';
import { Box } from '@bymason-private/legacy-pattern-components';
import { DeviceActionsButton } from '@bymason-private/controller-shared-widgets';

import { routes } from '../../router';
import Layout from '../../common/layout';
import { LegacyDeviceDetailsView } from './device-details';

type SubView = 'info' | 'software' | 'connectivity' | 'remote' | 'logs';

interface DeviceViewProps {
  deviceId?: string;
  subView?: SubView;
  hideXrayTabs?: boolean;
}

export default function DeviceView({
  deviceId = '',
  subView = 'info',
  hideXrayTabs = false,
}: DeviceViewProps) {
  const [deviceName, setDeviceName] = useState('');

  const handleDeviceInfoLoaded = (info: DeviceModel) => {
    setDeviceName(info && info.name ? info.name : `Device-${deviceId.substr(0, 8)}`);
  };

  return (
    <Layout
      divider={false}
      headerRightAdornment={
        <Box display='flex'>
          <DeviceActionsButton deviceId={deviceId} />
        </Box>
      }
      headerText={deviceName ? deviceName : 'Retrieving device info...'}
    >
      <LegacyDeviceDetailsView
        deviceId={deviceId}
        subView={subView}
        hideXrayTabs={hideXrayTabs}
        connectivityViewRoute={routes.ConnectivitySims}
        deviceViewRoute={routes.Device}
        groupViewRoute={routes.Group}
        projectViewRoute={routes.Project}
        onDeviceInfoLoad={handleDeviceInfoLoaded}
      />
    </Layout>
  );
}
